import { Tooltip, Avatar } from 'antd'
import React from 'react'
import { Personne } from '../../types'

interface D4AvatarProps extends Omit<Personne, 'id' | 'nom' | 'prenom'> {
  role: string | undefined
  noTooltip?: boolean
  nom: string | undefined | null
  prenom: string | undefined | null
}

const Color: Record<string, string> = {
  gestionnaire: '#91c800',
  'gestionnaire-sedentaire': '#1890ff',
  comptable: '#f56a00',
  personne: '#9b00f5',
}

const D4Avatar = ({ nom, prenom, role, noTooltip }: D4AvatarProps) => {
  if (!nom && !prenom) return null

  const avatar = (
    <Avatar style={{ backgroundColor: Color[role ?? ''] }}>{`${prenom?.[0]?.toUpperCase() || ''} ${
      nom?.[0]?.toUpperCase() || ''
    }`}</Avatar>
  )
  if (noTooltip) {
    return avatar
  }
  return (
    <Tooltip title={`${prenom} ${nom} (${role})`} placement="top">
      {avatar}
    </Tooltip>
  )
}

export default D4Avatar
